<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'AccordionContent',
});
</script>
